import styles from "@styles/containers/cdp/customer-coupons.module.scss";
import dayjs from "dayjs";
import { Benefit } from "shared/core/Benefit";

import classNames from "classnames/bind";
import { useEffect, useState } from "react";
import { If } from "shared/components/control-statements";
import { Button } from "@components";
import { Environment } from "shared/core/Environment";
const css = classNames.bind(styles);

const days = [
  {
    key: 0,
    full: "Dom",
  },
  {
    key: 1,
    full: "Seg",
  },
  {
    key: 2,
    full: "Ter",
  },
  {
    key: 3,
    full: "Qua",
  },
  {
    key: 4,
    full: "Qui",
  },
  {
    key: 5,
    full: "Sex",
  },
  {
    key: 6,
    full: "Sab",
  },
];

const mountTimes = (interval) => {
  const start =
    dayjs(interval.start, "HHmm").minute() === 0
      ? dayjs(interval.start, "HHmm").format("HH[h]")
      : dayjs(interval.start, "HHmm").format("HH:mm[h]");

  const end =
    dayjs(interval.end, "HHmm").minute() === 0
      ? dayjs(interval.end, "HHmm").format("HH[h]")
      : dayjs(interval.end, "HHmm").format("HH:mm[h]");

  return `${start}-${end}`;
};

const getTimes = (times) => {
  return times.map(mountTimes).join(", ");
};

const getStatus = (status) => {
  const statuses = {
    PENDING: "Disponível",
    USED: "Utilizado",
    LOCKED: "Travado",
    EXPIRED: "Expirado",
    DELETED: "Removido",
  };

  if (statuses[status]) return statuses[status];
};

export const getOrigin = (coupon) => {
  if (coupon.origin.flow) {
    return `Adicionado pelo fluxo ${coupon.origin.flow.name}`;
  }

  if (coupon.origin.user) {
    return `Adicionado por ${coupon.origin.user.username}`;
  }

  return "Adicionado manualment pelo usuário";
};

export const getDeleteOrigin = (coupon) => {
  
  if (!coupon.deleted_at) {
    return '';
  }

  const userName = coupon.deleted_by?.name;
  const deletedAt = dayjs(coupon.deleted_at).format('DD/MM/YY');
  
  if (!userName) {
    return deletedAt;
  }

  return `${deletedAt} por ${coupon.deleted_by.username}`;
}

const Coupon = ({ coupon, onRemove }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [loading, setLoading] = useState(false);

  const rules = Benefit.getRules(coupon);

  const expiresAt = coupon.add_until
    ? dayjs(coupon.add_until).format("DD/MM/YY")
    : null;
  const createdAt = dayjs(coupon.created_at).format("DD/MM/YY");

  const handleRemove = async () => {
    setLoading(true);

    const confirmed = await window.confirm({
      text: `Você tem certeza que deseja remover o cupom ${coupon.code}${Environment.id === 51 ? `-${coupon.pin}` : ""} do cliente? Esta ação não poderá ser desfeita.`,
      confirmText: "Sim",
      cancelText: "Cancelar",
    });

    if (!confirmed) {
      setLoading(false);
      return false;
    }

    try {
      await onRemove();
    } catch (err) {
      alert({ text: err.message });
    }
    
    setLoading(false);
  };

  useEffect(() => {
    setCollapsed(false);
    setLoading(false);
  }, [coupon]);

  return (
    <div className={css({ coupon: true, collapsed: collapsed })}>
      <div className={styles.header}>
        <div className="d-flex align-center">
          <p className={styles.code}>
            {coupon.code}-{coupon.pin}
          </p>
          <span className={styles.dot} />
          <p className={styles.type}>{getStatus(coupon.status)}</p>
        </div>
        <div
          className={css({ collapseDetails: true, collapsed: collapsed })}
          onClick={() => setCollapsed(!collapsed)}
        >
          <p>{collapsed ? "Ocultar detalhes" : "Ver detalhes"}</p>
          <i className="fas fa-chevron-down" />
        </div>
      </div>

      <div className={css({ details: true, show: collapsed })}>
        <p className={styles.title}>Vínculo</p>

        <If cond={Object.keys(coupon.origin).length > 0}>
          <p>Origem: {getOrigin(coupon)}</p>
        </If>

        <p>Adicionado em: {createdAt}</p>

        <If cond={expiresAt}>
          <p>Expiração: {expiresAt}</p>
        </If>

        <If cond={coupon.deleted_at}>
          <p>Removido em: {getDeleteOrigin(coupon)}</p>
        </If>
      </div>
      {(rules || []).length > 0 && (
        <div className={css({ details: true, show: collapsed })}>
          <p className={styles.title}>Regras</p>
          <ul>
            {rules.map((rule, index) => (
              <li key={`rule-${index}`}>{rule}</li>
            ))}
          </ul>
        </div>
      )}

      {(coupon.visibility || [])?.length > 0 ? (
        <div className={css({ details: true, show: collapsed })}>
          <>
            <p className={styles.title}>Disponível para uso</p>
            <ul>
              {coupon.visibility.map((v) => (
                <li key={v.weekDay}>
                  {days[v.weekDay].full}: {getTimes(v.times)}
                </li>
              ))}
            </ul>
          </>
        </div>
      ) : null}

      {collapsed && ['PENDING', 'LOCKED'].includes(coupon.status) && (
        <div className="mt-10 mt-10 w-100 d-flex justify-center">
          <Button
            design="underline"
            disabled={loading}
            onClick={handleRemove}
          >
            Remover cupom
          </Button>
        </div>
      )}
    </div>
  );
};

export default Coupon;
